<template>
  <div :class="[`bg-${$route.meta.background}`]">
    <Preloader v-if="isLoading" />
    <Sidebar></Sidebar>
    <MobileMenu></MobileMenu>
    <template v-if="!isOfficeLogin">
      <HomeworkMobile v-model="onboardingMobileActive" />
      <HomeworkDesktop v-model="onboardingDesktopActive" />
    </template>
    <div class="taskdetails">
      <div class="taskdetails__logo">
        <img class="taskdetails__logo-mobile" src="@/assets/images/brand/logo.svg" />
        <img class="taskdetails__logo-desktop" src="@/assets/images/brand/logo_full.svg" />
      </div>
      <div class="taskdetails__nav">
        <router-link :to="{ name: 'Main.Homeworks' }">
          <img class="mobile" src="@/assets/images/icons/right-arrow.svg" />
          <img class="desktop" src="@/assets/images/icons/close.svg" />
        </router-link>
      </div>
      <div class="taskdetails__content">
        <div class="taskdetails__header">
          <h3 class="taskdetails__title">
            {{ $t("dashboard.lector_add_task") }}
          </h3>
          <button @click="startOnlyOnboarding" class="onboarding-button">
            <div class="flex items-center">
              <img id="classes-homework" src="@/assets/images/icons/i_pink.svg" />
              <p class="ml-2 text-pink-main text-lg font-medium">Zobacz jak to działa</p>
            </div>
          </button>
        </div>
        <div class="taskdetails__box">
          <HomeworkSummaryDetails :subject="homework?.lesson?.homeworkSubject"
            :dueDate="formatDate(homework?.lesson?.date, true)" :status="homework?.status"/>
          <!-- <div class="taskdetails__box-desc">
            <div class="taskdetails__box-date">
              <img
                class="taskdetails__date-icon"
                src="@/assets/images/icons/clock.svg"
              />
              <span>{{ $t("dashboard.todo") }}</span>
              <span v-if="homework && homework.lesson">{{ formatDate(homework.lesson.date) }}</span>
            </div>
            <template v-if="formattedTaskTitle">
              <h4 v-html="formattedTaskTitle"></h4>
            </template>
          </div> -->
          <span class="taskdetails__spacer" />
          <!-- <h4 class="taskdetails__subtitle">Wgrane pliki</h4> -->
          <div class="taskdetails__box-uploader">
            <Uploader v-if="homework && homework.lesson && homework.lesson.homeworkSubject"
              @sent-files="showModalBeforeLeave">
            </Uploader>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import swal from "sweetalert2/dist/sweetalert2.js";
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';

import Preloader from '@/components/Preloader.vue';
import Sidebar from '@/components/Sidebar/Sidebar.vue';
import MobileMenu from '@/components/MobileMenu.vue';
import Uploader from '@/components/Uploader/Uploader.vue';
import HomeworkSummaryDetails from '@/components/Homeworks/HomeworkSummaryDetails.vue';

import HomeworkMobile from '@/components/Popup/HomeworkMobile.vue';
import HomeworkDesktop from '@/components/Popup/HomeworkDesktop.vue';

import fileSvg from '@/assets/images/icons/files.svg';

export default {
  name: 'HomeworkDetails',

  components: {
    Sidebar,
    MobileMenu,
    Preloader,
    Uploader,
    HomeworkMobile,
    HomeworkDesktop,
    HomeworkSummaryDetails,
  },

  data() {
    return {
      windowWidth: 0,
      onboardingMobileActive: false,
      onboardingDesktopActive: false,
      isFilesSent: true,
    };
  },

  computed: {
    ...mapState('students', ['student']),
    ...mapState('layout', ['isLoading']),
    ...mapGetters('homeworks', ['getHomeworkById']),
    ...mapGetters('auth', ['isOfficeLogin']),
    ...mapGetters('onboarding', [
      'getOnboardingProperty',
    ]),
    isMobileOnboardingDone() {
      return this.getOnboardingProperty({ deviceType: 'mobile', property: 'singleHomework' });
    },
    isDesktopOnboardingDone() {
      return this.getOnboardingProperty({ deviceType: 'desktop', property: 'singleHomework' });
    },

    homework() {
      return this.getHomeworkById(Number(this.$route.params.id));
    },

    formattedTaskTitle() {
      if (this.homework && this.homework.lesson) {
        const text = this.homework.lesson.homeworkSubject;
        const title = text.replace(/(\r\n|\n|\r)/gm, ' ');
        const urlRegex = /(?:https?|ftp):\/\/[\n\S]+/g;
        const url = title.match(urlRegex);
        if (url?.length) {
          const textBefore = title.match(/^.*?(?=(?:https?|ftp):\/\/[\n\S]+)/);
          const lastLink = url[url.length - 1];
          const textAfter = title.split(lastLink).pop();
          const links = Object.keys(url).map(key => `<a class="homeworkBtn" href="${url[key]}" target="_blank">${this.$t('dashboard.show_task')}</a>`);
          return `${textBefore?.length ? `
          <p class="mb-3">Zadanie: <strong>${textBefore[0]}</strong></p>` : ''}
          <p class="mb-4 font-normal">${this.$t('dashboard.show_task_prefix')}</p>
          <div class="homeworkBtn_wrapper">${links.join('')}</div>
          ${textAfter ? `<p>Zadanie: <strong>${textAfter}</strong></p>` : ''}`;
        }
        return `<p>Zadanie: <strong>${title}</strong></p>`;
      }
      return null;
    },
  },

  methods: {
    getWindowWidth() {
      this.windowWidth = window.innerWidth;
      Event.$emit('cancelTour');
    },

    formatDate(date, withDots = false) {
      if (withDots) {
        return moment(date).format('DD.MM.YYYY');
      }
      return moment(date).format('DD-MM-YYYY');
    },

    showModalBeforeLeave(isSent) {
      this.isFilesSent = isSent;
    },

    async showExitModal(next) {
      const { value } = await swal.fire({
        title: this.$t('modal.exit.title'),
        text: this.$t('modal.exit.text'),
        confirmButtonText: this.$t('modal.exit.confirm'),
        cancelButtonText: this.$t('modal.exit.cancel'),
        imageUrl: fileSvg,
        imageWidth: 120,
        imageHeight: 120,
        reverseButtons: true,
        buttonsStyling: false,
        showCancelButton: true,
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
        },
      });
      if (!value) {
        next();
      }
    },

    startDesktopOnboarding() {
      this.onboardingDesktopActive = !this.onboardingDesktopActive;
    },

    startMobileOnboarding() {
      this.onboardingMobileActive = !this.onboardingMobileActive;
    },

    startOnlyOnboarding() {
      if (this.windowWidth < 992) {
        this.onboardingMobileActive = !this.onboardingMobileActive;
      } else {
        this.onboardingDesktopActive = !this.onboardingDesktopActive;
      }
    },

    checkIfTourCookieExist() {
      if (!this.student?.id || !this.student?.onboardingMobile || !this.student?.onboardingDesktop) return;

      setTimeout(() => {
        const isMobile = this.windowWidth < 992;

        const profileMobileOnboarding = this.student?.onboardingMobile?.singleHomework;
        const profileDesktopOnboarding = this.student?.onboardingDesktop?.singleHomework;

        if (isMobile) {
          if (!profileMobileOnboarding) {
            this.startMobileOnboarding();
          }
        } else if (!profileDesktopOnboarding) {
          this.startDesktopOnboarding();
        }
      }, 500);
    },
  },

  created() {
    if (!this.student || Object.keys(this.student).length === 0) {
      this.routerPush({ name: 'Auth.Welcome' });
    } else if (this.homework === undefined) {
      this.routerPush({ name: 'Main.Homeworks' });
    } else {
      this.$store.commit('layout/startLoading');
    }
  },

  mounted() {
    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', this.getWindowWidth);
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.$store.commit('layout/finishLoading');
      this.checkIfTourCookieExist();
    }, 500);
  },

  beforeRouteLeave(to, from, next) {
    if (this.isFilesSent) {
      next();
    } else {
      next(false);
      this.showExitModal(next);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowWidth);
  },
};
</script>

<style lang="scss" scoped>
.taskdetails {
  @apply flex flex-col relative;
  max-width: calc(900px + 78px + 155px);
  min-height: 100vh;
  padding-top: 30px;
  padding-bottom: 78px;

  @media screen and (min-width: 992px) {
    margin-left: 312px;
  }

  &__logo {
    @apply w-full;
  }

  &__logo-mobile {
    @apply w-14 h-14 mx-auto block;

    @media screen and (min-width: 992px) {
      @apply hidden;
    }
  }

  &__logo-desktop {
    @apply mt-4 hidden;

    @media screen and (min-width: 992px) {
      @apply block;
      transform: translateX(78px);
    }
  }

  &__nav {
    @apply absolute;
    top: 46px;
    left: 16px;

    @media screen and (min-width: 992px) {
      right: 155px;
      left: auto;
    }

    a {
      @apply flex justify-center items-center w-6 h-6;
    }

    img.mobile {
      @media screen and (min-width: 992px) {
        @apply hidden;
      }
    }

    img.desktop {
      @apply hidden;
      width: 14px;
      height: 14px;

      @media screen and (min-width: 992px) {
        @apply block;
      }
    }
  }

  &__header {
    @apply flex flex-col items-start pb-8;

    @media screen and (min-width: 992px) {
      @apply flex-row items-center;
    }

    .onboarding-button {
      @apply ml-0 mt-4;
      white-space: nowrap;

      @media screen and (min-width: 992px) {
        @apply mt-1 ml-4;
      }
    }
  }

  &__title {
    @apply text-2xl font-semibold;

    @media screen and (min-width: 992px) {
      @apply text-4xl;
    }
  }

  &__content {
    @apply flex flex-col mx-auto w-full pt-8 px-4 relative;
    min-height: calc(100vh - 150px);

    @media screen and (min-width: 992px) {
      @apply px-0 w-auto;
      margin-left: 78px;
      margin-right: 155px;
    }

    /* @media screen and (min-width: 768px) {
      @apply w-4/5;
    }
    @media screen and (min-width: 1000px) {
      @apply w-3/5;
    }
    @media screen and (min-width: 1450px) {
      @apply w-1/3;
    } */
  }

  &__spacer {
    content: '';
    width: 100%;
    margin-top: 40px;
    margin-bottom: 40px;
    height: 1px;
    background-color: #E7E9EE;
  }

  &__subtitle {
    color: var(--grey-900, #111724);

    /* H4 */
    font-family: "GT Walsheim Pro";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
  }

  &__box {
    @apply flex flex-col p-6 relative bg-white rounded-lg;
    line-height: 21px;
    box-shadow: 0px 2px 10px 0px rgba(225, 225, 225, 0.50);

    @media screen and (min-width: 992px) {
      @apply p-8 m-0;
    }

    &-date {
      @apply flex flex-wrap items-center mb-6 font-bold;
      column-gap: 4px;
    }
  }
}

.fade-animation-enter-active {
  transition: all 0.4s ease;
}

.fade-animation-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-animation-enter,
.fade-animation-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>

<style lang="scss">
.homeworkBtn_wrapper {
  @apply flex flex-wrap justify-start mb-6;
  column-gap: 24px;
  row-gap: 12px;
}

.homeworkBtn {
  @apply block bg-white text-pink-main cursor-pointer text-sm font-bold;
  padding-left: 20px;
  padding-right: 20px;
  text-decoration: none;
  line-height: 36px;
  border: 1px solid #ec268f;
  border-radius: 20px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover {
    @apply bg-pink-dark-main text-white;
    border-color: #bd1e72;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
}
</style>
